/*
 * @Author: liyxt
 * @Date: 2020-06-02 10:49:51
 * @LastEditors: bbqin
 * @LastEditTime: 2022-11-08 15:15:15
 * @Description: file content
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import OriginTable from 'bee-table';
import sort from 'bee-table/build/lib/sort';
import Icon from 'bee-icon';
import bigData from 'bee-table/build/lib/bigData';
import dragColumn from 'bee-table/build/lib/dragColumn';
import multiSelect from 'bee-table/build/lib/multiSelect';
import singleSelect from 'bee-table/build/lib/singleSelect';
import sum from 'bee-table/build/lib/sum';
import { getMultiLang, isFunction, PubSub, getGlobalStorage, myBrowser, isString, isNumber } from '@platform/api';
import { createAffixScroll, affixScrollPosition } from './affixScroll';
import classnames from 'classnames';
import { TableColSetting, removeTableListener } from './nc_tableColSetting'
// tinper提供的计算滚动条宽度的方法
import { measureScrollbar } from "bee-table/build/lib/utils"

import 'bee-table/build/Table.css';
import './index.less'
//import '../-TableColSetting/index.less' //后面会删除
import 'bee-drawer/build/Drawer.css'; //后面会删除

const totalDefaultHeight = 28;

const DragTable = dragColumn(OriginTable);
const BigDataTable = bigData(DragTable);

// 统一兄弟区域变化表格重新计算标识
const BEFOREAREACHANGECOMPLETE = 'beforeAreaChangeComplete';
const AREACHANGECOMPLETE = 'areaChangeComplete';
// 页面其他区域变化表格重新计算标识
const OTHERCOMPLETE = 'otherComplete';
// 高度變化
const HEIGHTTOSCROLL = 'heightToScroll';
export default class Table extends Component {
    constructor(props) {
        super(props);
        this.state = { isEllipsis: true, columns: [], addRightShadow: false, currentIndex: -1, bodyColumn: props.columns };
        // 获取全局的个性化设置数据
        this.nccTable = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
        // 列设置
        this.TableColSetting = TableColSetting.bind(this);
        this.removeTableListener = removeTableListener.bind(this);
        this.browser = myBrowser()
        this.usePropsColumns = true;
        this.pubsubToken = [];
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => {
                });
            }
        };
        getMultiLang({ moduleId: 'base_table', callback });
    }

    componentDidMount() {
        const {
            autoAffixScroll,
            adaptionHeight,
            inModal,
            cardType,
            addAffixScroll = true,
            cancelCustomRightMenu = true,
            extendRightMenu,
            foldingRowChange,
            colsSettingParam = {},
            showFoldRow,
            addBlankCol = true, // 该属性为了取消添加空白列而设置
        } = this.props;
        //创建底部滚动条
        addAffixScroll && createAffixScroll(this);
        //创建假滚动条
        this.createFakeScroll();
        this.addScrollEvent();
        // 表格自动计算滚动条
        if (autoAffixScroll) {
            // 统一兄弟区域变化表格重新计算
            this.pubsubToken.push(PubSub.subscribe(AREACHANGECOMPLETE, this.affixScrollEvent));
            // 监听页面其他其他变换导致表格重新计算
            this.pubsubToken.push(PubSub.subscribe(OTHERCOMPLETE, this.affixScrollEvent));
            // 高度变化
            this.pubsubToken.push(PubSub.subscribe(HEIGHTTOSCROLL, this.affixScrollEvent));
        }

        // 表格自适应高度
        if (adaptionHeight || inModal) {
            if (!inModal) {
                this.calculateHeight();
            }
            // 统一监听兄弟区域变化表格重新计算
            cardType && this.pubsubToken.push(PubSub.subscribe(BEFOREAREACHANGECOMPLETE, this.handlePubSubBeforeComplete))
            this.pubsubToken.push(PubSub.subscribe(AREACHANGECOMPLETE, this.handlePubSub));
            // 监听页面其他其他变换导致表格重新计算
            this.pubsubToken.push(PubSub.subscribe(OTHERCOMPLETE, this.handlePubSub));
            window.addEventListener('resize', this.resizeListener)
            this.pubsubToken.push(PubSub.subscribe('MODAL', this.handlePubSubModal));
        }
        // 添加空白列
        addBlankCol && this.addBlankCol();
        //列设置监听右键
        if ((!cancelCustomRightMenu || extendRightMenu || foldingRowChange) && this.table) {
            let { noColSetClass, colSetCallback } = colsSettingParam;
            this.TableColSetting({
                tableDom: this.table,
                noColSetClass,
                colSetCallback,
                removeCustomRightMenu: this.removeCustomRightMenu,
                showFoldRow,
                cancelCustomRightMenu: cancelCustomRightMenu,
                extendRightMenu: extendRightMenu,
            });
        }

    }

    // 从state上取宽度赋给props上传入的columns  参考的2111版本
    setColumnWidth = (bodyColumn, columns, treeTableRef = undefined) => {
        bodyColumn.forEach(val => {
            // if (val.attrcode === 'blankrow') {
            //     blankrowFlag = val
            // }
            columns.forEach(item => {
                // if (item.attrcode === 'opr' && item.fixed === "right") {
                //     isopr = true;
                // }
                // if (item.attrcode === 'blankrow') {
                //     propsBlankRow = false;
                // }
                if (
                    (val.attrcode && item.attrcode && val.attrcode === item.attrcode) ||
                    (val.dataIndex && item.dataIndex && val.dataIndex === item.dataIndex)
                ) {
                    //判断是否固定列
                    // if (val.itemtype !== "customer") {
                    //用于解决业务组一次渲染传不同模板问题

                    if (treeTableRef && item.attrcode === 'checkbox' && item.resetWidth) {
                        // 树表CheckBox列宽在有数据后计算出新的宽度时更新宽度使用props传进来的值
                        // console.log(item);
                        item.resetWidth = false;
                    } else if (val.width) {
                        //解决拖拽列宽之后，查询数据setstate，防止列宽回到原来状态
                        item.width = val.width;
                    }
                    // }
                }

                // 多级表头
                if (val.children?.length && item.children?.length && val.dataIndex === item.dataIndex) {
                    this.setColumnWidth(val.children, item.children)
                }
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextprops) {
        if (nextprops.rowKey === 'total-row') {
            this.setState({ bodyColumn: nextprops.columns })
            return
        }
        const { columns = [], treeTableRef, addBlankCol = true } = nextprops;
        const { bodyColumn } = this.state;
        let { otherAreaHeight: newOtherAreaHeight } = nextprops
        let { otherAreaHeight: oldOtherAreaHeight } = this.props
        //当edittable浏览态编辑态切换的时候，让分页组件去掉的时候，更顺滑
        if (newOtherAreaHeight !== oldOtherAreaHeight) {
            this.calculateHeight(newOtherAreaHeight)
        }
        // let blankrowFlag = undefined;
        // let isopr = false;
        //业务传进来的是否包含空白列
        // let propsBlankRow = true;
        // let bodyColumnLen = blankrowFlag ? bodyColumn.length - 1 : bodyColumn.length;
        // let newbodyColumnLen = columns.length;
        // if (nextprops.className !== 'total-row') {
        if (this.resetWidthFlag) {
            // console.log('重置了列宽');
        } else {
            this.setColumnWidth(bodyColumn, columns, treeTableRef);
        }

        //如果有空白列将空白列添加上
        // if (blankrowFlag && propsBlankRow) {
        //     if (isopr) {
        //         columns.splice(columns.length - 1, 0, blankrowFlag);
        //     } else {
        //         columns.push(blankrowFlag);
        //     }
        // }
        //这种情况是解决在弹窗中的表格空白列计算宽度错误
        // if (this.noAddBlankColFlag) {
        //     this.addBlankCol(columns)
        // }
        // }
        if (addBlankCol) {
            this.addBlankCol([...columns])
        } else {
            this.setState({ bodyColumn: [...columns] })
        }
        // 这里要重置下bodyColumn，否则排序就不好用了
    }

    componentDidUpdate(nextprops) {
        const {
            colsSettingParam = {},
            cancelCustomRightMenu = true,
            showFoldRow = true, //控制是否显示折行控制按钮
            foldingRowChange, //点击折行的回调
            extendRightMenu,
            adaptionHeight, inModal = false,
            addAffixScroll = true,
            cardType,
            // addBlankCol = true, // 该属性为了取消添加空白列而设置
        } = this.props
        if (adaptionHeight && !inModal && (nextprops.columns.length !== this.props.columns.length)) {
            this.calculateHeight();
        }
        addAffixScroll && createAffixScroll(this);
        this.createFakeScroll();
        this.addScrollEvent();
        this.resetWidthFlag = false;
        // 添加空白列
        // addBlankCol && this.addBlankCol();
        //列设置监听右键
        if ((!cancelCustomRightMenu || extendRightMenu || foldingRowChange) && this.table) {
            let { noColSetClass, colSetCallback } = colsSettingParam;
            this.TableColSetting({
                tableDom: this.table,
                noColSetClass,
                colSetCallback,
                removeCustomRightMenu: this.removeCustomRightMenu,
                showFoldRow,
                cancelCustomRightMenu: cancelCustomRightMenu,
                extendRightMenu: extendRightMenu,
            });
        }
        showFoldRow && this.autoFoldRow()
        // 固定列阴影
        let addRightShadow = this.addRightShadow()
        if (this.state.addRightShadow !== addRightShadow) {
            this.setState({ addRightShadow })
        }
        PubSub.publishSync(BEFOREAREACHANGECOMPLETE, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener);
        this.removeScrollEvent()
        this.removeTableListener(this.removeCustomRightMenu);
        // 取消订阅
        // 按理说两个表格实例的this.affixScrollEvent不是同一个对象 但是我错了  是同一个对象
        this.pubsubToken.forEach(token => {
            PubSub.unsubscribe(token);
        })
        this.pubsubToken = [];
        this.table = null;
    }

    resizeListener = () => {
        this.calculateHeight();
    }

    //再次触发鼠标点击事件后移除自定义右键菜单
    removeCustomRightMenu = (ev, flag) => {
        //点击菜单
        let target = ev.target;
        //当鼠标点击的不是列宽设置外的菜单，都移除右键自定义菜单
        if (target.classList.contains('insert_number')) return;
        if (!target.classList.contains('columnWidthSetting') || !target.classList.contains('insert_number') || flag) {
            let mouseRightMenu = document.getElementsByClassName('nc-table-setColumnMenu-wrap')[0];
            if (mouseRightMenu) {
                mouseRightMenu.parentNode.removeChild(mouseRightMenu);
            }
        }
    };

    // 添加滚动事件
    addScrollEvent() {
        this.bodyAreaScroll = false;
        this.affixScrollScroll = false;
        let { autoAffixScroll } = this.props;
        let affixScroll = this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea = this.table && this.table.querySelector('.u-table-body');

        let leftFixedArea = Array.from(this.table && this.table.querySelectorAll('.u-table-fixed-left .u-table-body-inner') || []).pop();
        let rightFixedArea = Array.from(this.table && this.table.querySelectorAll('.u-table-fixed-right .u-table-body-inner') || []).pop();

        bodyArea && bodyArea.addEventListener('scroll', this.addBodyAreaScrollEvent);
        bodyArea && bodyArea.addEventListener('wheel', this.addBodyAreaScrollWheelEvent);

        bodyArea && bodyArea.addEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);
        leftFixedArea && leftFixedArea.addEventListener('scroll', this.addBodyAreaScrollEvent);
        leftFixedArea && leftFixedArea.addEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        leftFixedArea && leftFixedArea.addEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);
        rightFixedArea && rightFixedArea.addEventListener('scroll', this.addBodyAreaScrollEvent);
        rightFixedArea && rightFixedArea.addEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        rightFixedArea && rightFixedArea.addEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);

        affixScroll && affixScroll.addEventListener('scroll', this.addAffixScrollScrollEvent);
        autoAffixScroll && this.addParentScorllerEvent();
    }

    // 去除滚动事件
    removeScrollEvent() {
        this.bodyAreaScroll = false;
        this.affixScrollScroll = false;

        let affixScroll = this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea = this.table && this.table.querySelector('.u-table-body');

        let leftFixedArea = Array.from(this.table && this.table.querySelectorAll('.u-table-fixed-left .u-table-body-inner') || []).pop();
        let rightFixedArea = Array.from(this.table && this.table.querySelectorAll('.u-table-fixed-right .u-table-body-inner') || []).pop();

        bodyArea && bodyArea.removeEventListener('scroll', this.addBodyAreaScrollEvent);
        bodyArea && bodyArea.removeEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        bodyArea && bodyArea.removeEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);
        affixScroll && affixScroll.removeEventListener('scroll', this.addAffixScrollScrollEvent);

        leftFixedArea && leftFixedArea.removeEventListener('scroll', this.addBodyAreaScrollEvent);
        leftFixedArea && leftFixedArea.removeEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        leftFixedArea && leftFixedArea.removeEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);
        rightFixedArea && rightFixedArea.removeEventListener('scroll', this.addBodyAreaScrollEvent);
        rightFixedArea && rightFixedArea.removeEventListener('wheel', this.addBodyAreaScrollWheelEvent);
        rightFixedArea && rightFixedArea.removeEventListener('mousedown', this.addBodyAreaScrollWheelDownEvent);

        this.removeParentScorllerEvent();
    }

    addAffixScrollScrollEvent = () => {
        if (this.bodyAreaScroll == true) {
            this.bodyAreaScroll = false;
            return;
        }
        let totalArea = this.table && this.table.querySelector('.total-row .u-table-body');
        let affixScroll = this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea = this.table && this.table.querySelector('.u-table-body');
        this.affixScrollScroll == true;
        // 表体滚动条事件
        // if (totalArea && affixScroll) totalArea.scrollLeft = affixScroll.scrollLeft;
        bodyArea && (bodyArea.scrollLeft = affixScroll.scrollLeft);
        // console.log('addAffixScrollScrollEvent trigger');
        this.bodyAreaScroll = false;
    }
    addBodyAreaScrollEvent = (e) => {
        if (this.affixScrollScroll == true) {
            this.affixScrollScroll = false;
            return;
        }
        let totalArea = this.table && this.table.querySelector('.total-row .u-table-body');
        let bodyArea = this.table && this.table.querySelector('.u-table-body');
        let affixScroll = this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        // console.log(444,this.table)
        this.bodyAreaScroll = true;
        // 表体滚动条事件
        // if (totalArea) totalArea.scrollLeft = bodyArea.scrollLeft;
        if (affixScroll) affixScroll.scrollLeft = bodyArea.scrollLeft;
        this.affixScrollScroll = false;
    }

    addBodyAreaScrollWheelDownEvent = event => {
        // 鼠标中键按下
        if (event.buttons === 4) {
            let bodyArea = this.table && this.table.querySelector('.u-table-body');
            event.stopPropagation();
            bodyArea.contains(event.target) && event.preventDefault();
        }
    }

    addBodyAreaScrollWheelEvent = event => {
        let { currentTarget, deltaX, deltaY } = event;
        console.log("🚀 ~ file: index.js ~ line 249 ~ Table ~ currentTarget, deltaX, deltaY", currentTarget, deltaX, deltaY)
        // if (Math.abs(deltaX) > Math.abs(deltaY)) {
        //     currentTarget.scrollLeft = currentTarget.scrollLeft + deltaX;
        // }
        // 不用管X，不然会出现滚动条消失的BUG
        if (Math.abs(deltaX) < Math.abs(deltaY)) {
            console.log('wheel trigger');

            try {
                let $parentElement = currentTarget,
                    $scrollElement = null;
                while ($parentElement) {
                    let overflow = window.getComputedStyle($parentElement).getPropertyValue('overflow-y');
                    // 由于dom变化  可能会导致本来没有滚动条的产生滚动条  所以所有dom都要加下这个逻辑
                    if ($parentElement.scrollHeight > $parentElement.clientHeight && overflow == 'auto') {
                        $scrollElement = $parentElement;
                        break;
                    }

                    $parentElement = $parentElement.parentElement;
                    // parent 目前不做处理  不再循环  让bottom为0
                    if ($parentElement === document.body) {
                        $scrollElement = null;
                        break;
                    }
                }
                if ($scrollElement) {
                    event.preventDefault();
                    window.updateTrigger = true;
                    $scrollElement.scrollTop = $scrollElement.scrollTop + deltaY / 2;
                    // currentTarget.parentNode.scrollTop = $scrollElement.parentNode.scrollTop + deltaY;
                    window.requestAnimationFrame(() => {
                        console.log('updateTrigger');
                        window.updateTrigger = false;
                    });
                } else {
                    window.updateTrigger = false;
                }
            } catch (error) {
                console.error(error);
                window.updateTrigger = false;
            }
        }
    }

    affixScrollEvent = () => {
        let affixScroll = this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        if (!affixScroll) {
            return;
        }
        affixScrollPosition(this);
    }

    // 固定滚动条的窗口改变计算
    addResizeEvent = () => {
        let { addAffixScroll = true, cardType } = this.props
        addAffixScroll && createAffixScroll(this);
        this.affixScrollEvent();
    }

    // 给父级可滚动元素添加事件
    addParentScorllerEvent() {
        if (!this.table) return;
        let $parentElement = this.table.parentElement;
        while ($parentElement) {
            $parentElement.addEventListener('scroll', this.affixScrollEvent);
            if ($parentElement === document.body) {
                document.addEventListener('scroll', this.affixScrollEvent);
                break
            }
            $parentElement = $parentElement.parentElement;
        }
    }

    removeParentScorllerEvent() {
        if (!this.table) return;

        let $parentElement = this.table.parentElement;
        while ($parentElement && $parentElement !== document.body) {
            $parentElement.removeEventListener('scroll', this.affixScrollEvent);
            $parentElement = $parentElement.parentElement;
        }
        document.body.removeEventListener('scroll', this.affixScrollEvent);
        document.removeEventListener('scroll', this.affixScrollEvent);
        window.removeEventListener('resize', this.addResizeEvent);
    }

    //折行
    autoFoldRow = () => {
        const {
            colsSettingParam = {},
            cancelCustomRightMenu = true,
            foldingRowChange, //点击折行的回调
            foldCacheId, //对于没有appcode，pagecode..的表格，做折行缓存的标志
            extendRightMenu,
        } = this.props
        if ((!cancelCustomRightMenu || extendRightMenu || foldingRowChange)) {
            let { appcode, pagecode, areaCode } = colsSettingParam;

            let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
            let userData = userDataJSON && JSON.parse(userDataJSON);
            let userid = userData && userData.userId;

            if (appcode && pagecode && areaCode) {
                this.fold_localStorage = 'foldFlag_' + appcode + '_' + pagecode + '_' + areaCode + '_' + userid;
            } else {
                this.fold_localStorage = foldCacheId + '_' + userid
            }
            if (this.fold_localStorage) {
                let fold_flag = getGlobalStorage('localStorage', 'fold_flag') || {}
                if (typeof fold_flag === 'string') {
                    fold_flag = JSON.parse(fold_flag)
                }
                let flag = fold_flag[this.fold_localStorage]
                let isEllipsis = flag !== 'isFold'
                if (isEllipsis === false && this.state.isEllipsis !== isEllipsis) {
                    this.setState({ isEllipsis })
                    isFunction(foldingRowChange) && foldingRowChange(isEllipsis)
                }
            }
        }
    }

    // 无数据样式（暂无数据）
    noData = () => {
        let { json = {}, tableHight } = this.state;
        let { adaptionHeight, bodyStyle = {} } = this.props
        let topValue = '53%'
        if (this.table) {
            let headerDom = this.table.querySelectorAll('.u-table-fixed')[0];
            let headerHeight = 36
            if (headerDom) {
                headerHeight = headerDom.offsetHeight;
            }
            headerHeight = headerHeight > 300 ? 36 : headerHeight;

            if (adaptionHeight) {
                topValue = tableHight / 2 + headerHeight - 13
            } else {
                let { minHeight, height } = bodyStyle

                if (height) {
                    if (isString(height)) {
                        height = Number(height.replace(/px/, ''));
                    }
                    topValue = height / 2 + headerHeight - 13
                } else if (minHeight) {
                    if (isString(minHeight)) {
                        minHeight = Number(minHeight.replace(/px/, ''));
                    }
                    topValue = minHeight / 2 + headerHeight - 13
                }
            }
            if (isNaN(topValue)) { topValue = '53%' }
            if (isNumber(topValue)) { topValue += 'px' }
            let nodataDom = this.table.querySelector('.u-table-placeholder')
            if (nodataDom) {
                nodataDom.style.top = String(topValue)
            }

        }

        return (
            <div className="no-data-placeholder" >
                <i className="no-data" />
                <span className="no-data-title">{json['base-table-0001']}</span>
            </div>
        );
    };

    // 表格之外其他区域变化高度回调
    handlePubSub = (msg, data) => {
        if (data) {
            // 计算表格高度, 延遲200毫秒，等待其他區域加載完再進行計算  // 去除
            // setTimeout(() => {
            this.calculateHeight();
            // }, 0);
        }
    };

    handlePubSubModal = (msg, data) => {
        //模态框下方的表格，模态框拖拽时，使表格高度自适应
        if (data.sence === 'modal' && data.currentModal && this.props.inModal) {
            this.resizeModal = true;
            let modalBody = data.currentModal.querySelector('.u-modal-body');
            let ncTableDom = modalBody && modalBody.querySelector('.nc-table');
            if (ncTableDom) {
                let bodyTop = modalBody.getBoundingClientRect().top;
                let bodyHeight = modalBody.offsetHeight;
                const paddingBottom = Number(this.getStyle(modalBody, 'paddingBottom').replace('px', ''));
                let tableTop = ncTableDom.getBoundingClientRect().top;
                // 合计行表格高度
                const totalHeight = this.props.isTotal ? totalDefaultHeight : 0;
                // 表头高度
                const headerHeight = ncTableDom.querySelectorAll('.u-table-thead')[0].offsetHeight;
                // 计算表格距离body位置
                this.setState({ tableHight: bodyHeight - (tableTop - bodyTop) - headerHeight - totalHeight - paddingBottom - 5 });
            }
        }
    }

    handlePubSubBeforeComplete = (msg, isSetAbsolute) => {
        if (!this.table) return;
        let wrapEl = this.table.parentElement.parentElement.parentElement;
        let buoy = ''
        if (this.state.tableHight > 210) {
            buoy = [
                'position: absolute',
                'left: 0',
                'right: 0',
                'bottom: 0',
                'z-index: 1',
                'padding:4px 8px 0 8px',
            ].join(';');
        }

        if (isSetAbsolute) {
            wrapEl.setAttribute('style', buoy);
        } else {
            wrapEl.removeAttribute('style');
        }
    }

    // 高度自适应计算
    calculateHeight = newOtherAreaHeight => {
        if (!this.table) { return }
        let wrapEl = this.table.parentElement.parentElement.parentElement;
        let parentEl = wrapEl.parentElement;
        let { cardType, isTotal, otherAreaHeight, currentIndex } = this.props;
        if (newOtherAreaHeight || newOtherAreaHeight === 0) {
            otherAreaHeight = newOtherAreaHeight
        }
        // 合计行表格高度
        let totalHeight = isTotal ? totalDefaultHeight : 0;
        if (isTotal && (this.myBrowser == 'IE' || this.myBrowser == 'Firefox' || this.myBrowser == 'Edge')) {
            totalHeight = 45;
        }
        /**
     * 表头高度
     * 对表头高度获取错误的情况做一下兼容,错误的时候取到的是表体高度
     * 目前只有树表有这种情况,所以只兼容单表头情况,等想到好办法在改一下这里
     */
        let headerDom = this.table.querySelectorAll('.u-table-thead')[0];

        let headerHeight = 36
        if (headerDom) {
            headerHeight = headerDom.offsetHeight;
        }
        headerHeight = headerHeight > 300 ? 36 : headerHeight;
        // 表格下方其他部分高度
        otherAreaHeight = otherAreaHeight || 0;
        let tableBody = this.table.querySelectorAll('.u-table-content')[0];
        const paddingBottom = Number(this.getStyle(document.body, 'paddingBottom').replace('px', ''));
        let top
        if (cardType) {
            top = parentEl.getBoundingClientRect().top;
        } else {
            top = this.table.getBoundingClientRect().top;
        }

        let tableHight = null;
        // 其他表格都是会多出页面头部的一部分存在外层window的时候，所以这里直接取里层的高度了，card除外所以另外处理
        let windowHeight = document.documentElement.clientHeight;
        if (top && tableBody) {
            tableHight =
                windowHeight -
                paddingBottom -
                top -
                headerHeight -
                totalHeight -
                otherAreaHeight - 3;
            // 对cardtable的专有判断, card布局有特殊情况,需要多减8
            if (cardType === 'card' && window.top) {
                tableHight = tableHight - 2;
            }
            let hasIndexTr = tableBody.querySelectorAll('.u-table-body tr[data-row-index]');
            let lastIndexTr = hasIndexTr && hasIndexTr[hasIndexTr.length - 1];
            currentIndex = currentIndex >= 0 ? currentIndex : (lastIndexTr ? Number(lastIndexTr.getAttribute('data-row-index')) / 2 - 1 : -1);
            tableBody = null;
            //表格最小高度210px
            if (tableHight < 210) {
                tableHight = 210
            }
            this.setState({ tableHight, currentIndex: Math.floor(currentIndex) }, () => {
                // if (cardType === 'card' || cardType === 'edit') {
                //     let scrollBody = this.table.querySelector('.u-table-body-inner,.u-table-body');
                //     scrollBody && scrollBody.scrollTop && (scrollBody.scrollTop--);
                // }
                PubSub.publishSync(BEFOREAREACHANGECOMPLETE, false);
            });
        } else {
            PubSub.publishSync(BEFOREAREACHANGECOMPLETE, false);
        }
    };

    // 获取元素的样式属性值
    getStyle = (obj, attr) => {
        if (obj.currentStyle) {
            return obj.currentStyle[attr];
        } else {
            return document.defaultView.getComputedStyle(obj, null)[attr];
        }
    };

    // 获取表格的行高
    getRowHeight = tableType => {
        switch (tableType) {
            case 'compact':
                return 24;
            case 'standard':
                return 28;
            case 'loose':
                return 36;
        }
    };

    // 平铺columns
    getArrColumn = (columns, newColumns) => {
        columns.forEach(item => {
            if (item.children) {
                this.getArrColumn(item.children, newColumns)
            } else {
                newColumns.push(item)
            }
        })
    }

    //空白列
    addBlankCol = (bodyColumn) => {
        if (bodyColumn === undefined) {
            bodyColumn = this.state.bodyColumn || [];
        }
        let blankrowFlag = true;
        if (bodyColumn.length && this.table) {
            bodyColumn.forEach(element => {
                if (element.attrcode == 'blankrow') {
                    blankrowFlag = false;
                }
            });
            if (blankrowFlag) {
                let obj = {
                    title: <div className={'fake-line'} />,
                    key: 'blankrow',
                    dataIndex: 'blankrow',
                    attrcode: 'blankrow',
                    className: 'blankrow',
                    visible: true,
                    itemtype: 'customer',
                    width: "1px",
                    render: () => <div />,
                };
                bodyColumn.push(obj);
            }

        }
        this.setState({ bodyColumn });
        // let tableWidth = 0;
        // if (bodyColumn.length && this.table) {
        //     tableWidth = this.table.getBoundingClientRect().width;
        //     if (tableWidth === 0) {
        //         this.noAddBlankColFlag = true;
        //         return;
        //     }
        //     if (bodyColumn.length < 3) {
        //         let attrcodeArr = new Set()
        //         bodyColumn.forEach(item => {
        //             attrcodeArr.add(item.attrcode)
        //         })
        //         if (attrcodeArr.has('checkbox') && attrcodeArr.has('numberindex')) {
        //             return
        //         }
        //         if (bodyColumn.length < 2) {
        //             if (attrcodeArr.has('checkbox') || attrcodeArr.has('numberindex')) {
        //                 return
        //             }
        //         }
        //     }
        // } else {
        //     return
        // }
        // //  mulHeaderFlag = false,
        // let blankrowFlag = false;
        // let isopr = false;
        // //最后一列是操作列，且不是固定列的flag
        // let oprNotFixFlag = false;
        // let attrcodeArr = []
        // let newColumns = []
        // this.getArrColumn(bodyColumn, newColumns)
        // newColumns.map(item => {
        //     if (item.attrcode == 'opr' && !item.fixed) {
        //         oprNotFixFlag = true;
        //     }
        //     if (item.attrcode === 'opr' && item.fixed === "right") {
        //         isopr = true;
        //     }
        //     if (item.attrcode == 'blankrow') {
        //         blankrowFlag = true;
        //     }
        //     attrcodeArr.push(item.attrcode);
        //     return item.attrcode;
        // });
        // //最后一列是固定列并且没有空白列的情况下添加空白列
        // if (!oprNotFixFlag && !blankrowFlag) {
        //     // let isopr = false;
        //     // if (attrcodeArr[attrcodeArr.length - 1] === 'opr') {
        //     //     isopr = true;
        //     // }
        //     let columnsWidth = 0;
        //     let newColumnsLength = newColumns.length;

        //     // if (isopr && blankrowFlag) {
        //     //     // 固定列或者空白列都存在就减去二个
        //     //     newColumnsLength = newColumnsLength - 2
        //     // } else if (isopr && !blankrowFlag) {
        //     //     newColumnsLength = newColumnsLength - 1
        //     // } else if (!isopr && blankrowFlag) {
        //     //     newColumnsLength = newColumnsLength - 1
        //     // }
        //     for (let i = 0; i < newColumnsLength; i++) {
        //         switch (typeof newColumns[i].width) {
        //             case 'undefined':
        //                 // columnsWidth = columnsWidth + 120;
        //                 // break;
        //                 //模板没有宽度的话就不加空白列了
        //                 return;
        //             case 'number':
        //                 columnsWidth = columnsWidth + newColumns[i].width;
        //                 break;
        //             case 'string':
        //                 let a = newColumns[i].width;
        //                 columnsWidth = Number(a.replace(/px/, '')) + columnsWidth;
        //                 //当业务传的宽度是%时，不添加空白列
        //                 if (isNaN(columnsWidth)) return;
        //                 break;
        //         }
        //     }
        //     // 左固定列1px 右固定列1px 滚动条宽度使用bee-table的计算方法measureScrollbar
        //     let lastColWidth = this.table.getBoundingClientRect().width - columnsWidth - 2 - measureScrollbar();
        //     let obj = {
        //         title: <div className={'fake-line'} />,
        //         key: 'blankrow',
        //         dataIndex: 'blankrow',
        //         attrcode: 'blankrow',
        //         className: 'blankrow',
        //         visible: true,
        //         itemtype: 'customer',
        //         width: lastColWidth,
        //         render: () => <div />,
        //     };
        //     if (lastColWidth > 0) {
        //         // bodyColumn.push(obj)
        //         // if (isopr) {
        //         //     if (blankrowFlag) {
        //         //         bodyColumn.splice(bodyColumn.length - 2, 1, obj);
        //         //     } else {
        //         //         bodyColumn.splice(bodyColumn.length - 1, 1, obj);
        //         //     }
        //         // } else {
        //         //     if (blankrowFlag) {
        //         //         bodyColumn.splice(bodyColumn.length - 1, 1, obj);
        //         //     } else {
        //         //         bodyColumn.splice(bodyColumn.length, 0, obj);
        //         //     }
        //         // }
        //         if (isopr) {
        //             bodyColumn.splice(bodyColumn.length - 1, 0, obj);
        //         } else {
        //             bodyColumn.push(obj);
        //         }
        //         this.noAddBlankColFlag = false;
        //         this.setState({ bodyColumn })
        //     }
        // }
    };
    // 冻结列
    freezeColumns = columns => {
        columns.map(item => {
            if (item.islock && !item.fixed) {
                item.fixed = 'left';
            }
            return item
        })
    }
    onDraggingBorder = () => {
        this.createFakeScroll(true);
    }

    onDropBorder = () => {
        const { bodyColumn } = this.state;
        const { onDropBorderHandler } = this.props;
        // let colColumns = this.table.querySelectorAll('.u-table-scroll .u-table-header colgroup col')
        // let leftColumns = this.table.querySelectorAll('.u-table-fixed-left .u-table-header colgroup col')
        // let rightColumns = this.table.querySelectorAll('.u-table-fixed-right .u-table-header colgroup col')
        // for (let i = 0, len = bodyColumn.length; i < len; i++) {
        //     //删除空白列
        //     if (bodyColumn[i].attrcode === 'blankrow') {
        //         // bodyColumn.splice(i, 1)
        //     }
        // }
        // let len = bodyColumn.length;
        // for (let i = 0; i < len; i++) {
        //     //兼容多表头
        //     let childnum = 0; //子表头个数
        //     if (bodyColumn[i].children) {
        //         bodyColumn[i].children.map((child, childIndex) => {
        //             child.width = colColumns[i + childIndex].style.width;
        //         });
        //         childnum += bodyColumn[i].children.length - 1;
        //     } else {
        //         if (bodyColumn[i].fixed === 'left') {
        //             bodyColumn[i].width = leftColumns[i + childnum].style.width;
        //         } else if (bodyColumn[i].fixed === 'right') {
        //             bodyColumn[i].width = rightColumns[0].style.width;
        //         } else {
        //             bodyColumn[i].width = colColumns[i + childnum - leftColumns.length].style.width;
        //         }
        //     }
        // }
        // onDropAfter && onDropAfter(bodyColumn);
        this.setState({ bodyColumn }, () => {
            // table渲染完成后获取最新的列宽修改合计行的列宽
            // setTimeout(() => {
            onDropBorderHandler && onDropBorderHandler();
            // }, 300);
        })
    }

    createFakeScroll = isDropBorder => {
        const { isTotal, data } = this.props;
        // let { minHeight } = bodyStyle;
        let tableHaveData = Array.isArray(data) && data.length;
        let flag = false;
        //解决NCCLOUD-189979问题
        let bodyHeight = 60;
        if (this.table) {
            // 解决ie下tbody 没有宽度的问题
            let tableHeaderCenter = this.table.querySelector('.u-table-header table');
            let tableCenter = this.table.querySelector('.u-table-body');
            if (tableCenter && tableHeaderCenter) {
                let scrollWidth = tableHeaderCenter.getBoundingClientRect().width; //u-table-body 下 table标签宽度
                let fakeScroll = this.table.querySelector('.fake-scrollbar');
                //判断假滚动条是否是当前表格的子元素
                let isChildScroll = fakeScroll === tableCenter.lastChild;
                //没数据 没假滚动条
                if (!tableHaveData && !fakeScroll) {
                    flag = true;
                    //没数据 拖拽列宽
                } else if (!tableHaveData && isDropBorder) {
                    flag = true;

                    //有假滚动条 没数据
                } else if (fakeScroll && !tableHaveData && isChildScroll) {
                    if (fakeScroll.offsetWidth === scrollWidth) {
                        return
                    }
                    flag = true;
                    tableCenter.removeChild(fakeScroll);
                    //有假滚动条 有数据 去掉假滚动条
                } else if (fakeScroll && tableHaveData && isChildScroll) {
                    //有数据 去掉假滚动条
                    tableCenter.removeChild(fakeScroll);
                }
                if (flag) {
                    let fixheight = 20;
                    // if (this.myBrowser == 'IE' || this.myBrowser == 'Firefox') {
                    //     fixheight = 28;
                    // }
                    let top = bodyHeight - fixheight;
                    if (scrollWidth) {
                        if (isDropBorder) {
                            fakeScroll.setAttribute('style', `top:${top}px;width:${scrollWidth}px`);
                        } else {
                            let div = document.createElement('div');
                            if (isTotal) {
                                div.setAttribute('class', 'fake-scrollbar fake-scrollbar-transparent');
                            } else {
                                div.setAttribute('class', 'fake-scrollbar');
                            }
                            div.setAttribute('style', `top:${top}px;width:${scrollWidth}px`);
                            tableCenter.appendChild(div);
                        }
                    }
                }
            }
        }
    };

    addRightShadow = () => {
        let tablebody = this.table && this.table.querySelector('.u-table-body table');
        if (tablebody) {
            let haveScrollbar = tablebody.scrollWidth > tablebody.offsetWidth
            return haveScrollbar
        }
    }

    render() {
        const {
            lazyload = true,
            isDrag = true,
            className,
            autoAffixScroll,
            columns,
            showFoldRow = true,
            adaptionHeight,
            inModal = false,
            isTotal,
            rowKey,
            customRowHeight = false, // false时自定义显示行高, 不按照个性化的规则显示行高
        } = this.props;
        const { bodyColumn } = this.state;
        const ThisTable = lazyload ? BigDataTable : DragTable;
        let {
            tableType = 'standard', // tableType:'compact'紧凑'standard'标准'loose'宽松
            crossCheck = false, // crossCheck 是否斑马线
            cuttingCheck = true, // cuttingCheck 是否分割线
        } = this.nccTable;
        this.freezeColumns(bodyColumn)
        const isMultiHeader = bodyColumn.some(item => item.children);
        showFoldRow && this.autoFoldRow()
        const rowHeight = this.getRowHeight(tableType);

        let height = customRowHeight ? {} : (this.props.height ? { height: this.props.height } : { height: rowHeight });
        if (!this.state.isEllipsis) {
            height = undefined
            tableType = ''
        }
        const adaptionHeightParam =
            adaptionHeight || (inModal && this.resizeModal)
                ? {
                    bodyStyle: { height: inModal && !this.state.tableHight ? 210 : this.state.tableHight },
                    scroll: { y: this.state.tableHight },
                    // 这个属性是避免，计算之后页面自动滚动到顶部
                    ignoreScrollYChange: true,
                    // tinper不行 老是出bug 我只能自己处理了 TODO
                    // currentIndex: this.props.currentIndex >= 0 ? this.props.currentIndex : this.state.currentIndex,
                }
                : {};
        let dataLength = this.props.data ? this.props.data.length : 0;
        let handleFooter = isTotal && (rowKey !== 'total-row') ? this.props.handleFooter : null;
        return (
            <div className="base-nc-table-wrapper base-u-table-wrapper"> {/* 加这一层的目的是为了处理标准样式border,border直接加bee-table上会导致tinper横向滚动条计算错误*/}
                <ThisTable
                    columnKey='attrcode'
                    loadBuffer={2}
                    dragborder={isDrag}
                    minColumnWidth={56}//解决序号列或者复选框列拖动列宽后无法拖小问题
                    emptyText={this.noData}
                    bodyStyle={{ minHeight: '160px' }}
                    scroll={{ //使用悬浮滚动条一定要加这个属性，不然会报错
                        y: 300,
                    }}
                    footer={handleFooter === null ? null : () => handleFooter([...bodyColumn])}
                    {...this.props}
                    columns={[...bodyColumn]}
                    className={classnames('nc-table', 'scrollbar-mod', `${tableType}`,
                        {
                            "cross": crossCheck,
                            // "cutting": cuttingCheck,
                            'nc-table-auto-affix': autoAffixScroll,
                            'compatible-browser-fixCol': dataLength < 2,
                            'compatible-browser-body': dataLength === 0,
                            'right-box-shadow': this.state.addRightShadow,
                            'no-right-box-shadow': !this.state.addRightShadow,
                            'multi-table-header': isMultiHeader,
                        },
                        className)}
                    bordered={cuttingCheck}
                    {...height}
                    ref={dom => {
                        if (dom) {
                            this.table = ReactDOM.findDOMNode(dom);
                            if (this.props.treeTableRef) {
                                this.props.treeTableRef.current = dom;
                            }
                        }
                    }}
                    headerScroll={false}
                    hideHeaderScroll={true}
                    onDraggingBorder={() => {
                        this.onDraggingBorder()
                    }}
                    onDropBorder={(e, width) => {
                        this.onDropBorder(e, width)
                    }}
                    {...adaptionHeightParam}
                    headerEventNoStop
                />
            </div>

        );
    }
}

Table.SortTable = sort(Table, Icon);

// 高阶组件
Table.sort = sort;
Table.bigData = bigData;
Table.dragColumn = dragColumn;
Table.multiSelect = multiSelect;
Table.singleSelect = singleSelect;
Table.sum = sum;